export default __webpack_public_path__ + "static/media/Group_7470.124f65df.png";